export default "__VITE_ASSET__MtsOqbHG__"